import React from "react";
import { Component } from "react";
import SingleSlider from "./SingleSlider";
import LoginViewSlider from "./LoginViewSlider";
import AuthenticationSlider from "./AuthenticationSlider";

export default class LoginSlider extends Component {

    state = {
        list1: [

            { name: 'Overview of workload by person and project' },
            { name: 'Project milestones viewable' },
            { name: 'Capacity trendline by person' },
            { name: 'Drag-and-drop task scheduling' },
            { name: 'Filtered views by role and person' },
            { name: 'Customized capacity thresholds per person' },

        ],
        list2: [
            { name: 'Option to drill into tasks for more info' },
            { name: 'Expanded timeline for planning' },
            { name: 'Hover states for individual effort stats' },
            { name: 'Multi-select bulk rescheduling' },
            { name: 'Effort in hours, points, or any value' },
            { name: 'Assign new work with the unscheduled tasks pane' }
        ],
        timerPercentage: 0,
        active: 0,


    }

    render() {
        var active = this.state.active;
        return (
            <div className='w-100 h-100 d-flex flex-column scroll-no-scrollbar' style={{}}>
                <AuthenticationSlider slideTimer={2000} buttons={true} handleClick={this.props.handleClick} active={this.props.active}>
                    {this.props.items.map((prop, index) => {
                        return (
                            <LoginViewSlider key={index} width={this.props.width} setColor={this.props.setColor} bg={prop.bg} title={prop.title} des={prop.des} />
                        )
                    })}
                </AuthenticationSlider>
            </div >
        );
    }

}